module.exports = __webpack_public_path__ + "static/media/number-flower.005d4aaf.mp4";